// MUI-free copy of Ui-components/OurMakeChoice.
import {memo} from 'react';
import type {ReactNode} from 'react';
import parse from 'html-react-parser';
import Container from '@/components/atoms/Container';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import {cdnImage} from '@/util/cdnImage';
import styles from './OurMakeChoice.module.scss';

const check = cdnImage('Home-page/check.svg');

export interface OurMakeChoiceItem {
    heading?: string;
    subheading?: string;
}

interface OurMakeChoiceProps {
    heading?: ReactNode;
    subheading?: ReactNode;
    body?: string[];
    contentData?: OurMakeChoiceItem[];
}

const OurMakeChoice = ({heading, subheading, body, contentData}: OurMakeChoiceProps) => (
    <div className="make-our-white-label-wrapper bg-blue-background">
        <Container>
            <div className={styles.grid}>
                <div className={styles.item}>
                    {heading && <p className={`makes-our-heading font-headers ${styles.text}`}>{heading}</p>}
                    {subheading && <p className={`makes-our-subheading font-headers ${styles.text}`}>{subheading} </p>}
                    {body?.map((item, index) => (
                        <p className={`makes-our-body ${styles.text}`} key={index + 1}>
                            {parse(item)}
                        </p>
                    ))}
                </div>
                <div className={`${styles.item} trading-item-main-wrapper`}>
                    {contentData?.map((item, index) => (
                        <div className="done-icon-wrapper" key={index + 1}>
                            <div className={styles.iconBox}>
                                <OptimizedImage src={check} alt="check Icon" width={22} priority={false} />
                            </div>
                            <div>
                                {item?.heading && <p className={`done-heading font-headers ${styles.text}`}>{parse(item.heading)}</p>}
                                {item?.subheading && <p className={`done-subheading  ${styles.text}`}>{parse(item.subheading)}</p>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    </div>
);

export default memo(OurMakeChoice);
